import { canUseDOM } from 'exenv';
import asyncAuthorPageAction from '../../../../redux/actions/author/async_author_page_actions';
import log from '../../../../services/logger_service';

export default function fetchDataWithStore(store) {
  return function fetchData(nextState, replace, callback) {
    const { dispatch } = store;
    // run async
    if (canUseDOM) {
      if (store.getState().config.initialPageLoad === true) {
        if (callback) {
          return callback();
        }
        return false;
      }
      asyncAuthorPageAction(nextState.params, store)(dispatch);
      if (callback) {
        return callback();
      }
      return false;
    }
    // run sync
    return asyncAuthorPageAction(nextState.params, store)(dispatch)
      .then(function cb() {
        if (callback) {
          return callback();
        }
        return false;
      })
      .catch(function handleActionError(error) {
        log.fatal(
          error,
          `Fatal error in onEnter state manager: ${error.message}`
        );
        if (callback) {
          return callback();
        }
        return false;
      });
  };
}
